import {rebindOnMethod} from '../../modules/util';

export default function(listeners) {
  return rebindOnMethod(this, listeners);
}


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/rebindOnMethod.js